/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { StatusResponse } from './';
import {
    StatusResponseFromJSON,
    StatusResponseFromJSONTyped,
    StatusResponseToJSON,
} from './';

/**
 * 
 * @export
 * @interface ReferralSubmissionForReferrerResponse
 */
export interface ReferralSubmissionForReferrerResponse {
    /**
     * 
     * @type {StatusResponse}
     * @memberof ReferralSubmissionForReferrerResponse
     */
    status: StatusResponse;
    /**
     * Date of the referral submission
     * @type {Date}
     * @memberof ReferralSubmissionForReferrerResponse
     */
    submissionDate: Date;
    /**
     * 
     * @type {string}
     * @memberof ReferralSubmissionForReferrerResponse
     */
    projectTitle: string;
    /**
     * 
     * @type {string}
     * @memberof ReferralSubmissionForReferrerResponse
     */
    companyName: string;
    /**
     * 
     * @type {number}
     * @memberof ReferralSubmissionForReferrerResponse
     */
    referrerRate: number;
    /**
     * 
     * @type {string}
     * @memberof ReferralSubmissionForReferrerResponse
     */
    submissionId: string;
    /**
     * 
     * @type {string}
     * @memberof ReferralSubmissionForReferrerResponse
     */
    referrerAccountId: string;
    /**
     * 
     * @type {string}
     * @memberof ReferralSubmissionForReferrerResponse
     */
    referrerIdentityId: string;
}

/**
 * Check if a given object implements the ReferralSubmissionForReferrerResponse interface.
 */
export function instanceOfReferralSubmissionForReferrerResponse(value: object): value is ReferralSubmissionForReferrerResponse {
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('submissionDate' in value) || value['submissionDate'] === undefined) return false;
    if (!('projectTitle' in value) || value['projectTitle'] === undefined) return false;
    if (!('companyName' in value) || value['companyName'] === undefined) return false;
    if (!('referrerRate' in value) || value['referrerRate'] === undefined) return false;
    if (!('submissionId' in value) || value['submissionId'] === undefined) return false;
    if (!('referrerAccountId' in value) || value['referrerAccountId'] === undefined) return false;
    if (!('referrerIdentityId' in value) || value['referrerIdentityId'] === undefined) return false;
    return true;
}

export function ReferralSubmissionForReferrerResponseFromJSON(json: any): ReferralSubmissionForReferrerResponse {
    return ReferralSubmissionForReferrerResponseFromJSONTyped(json, false);
}

export function ReferralSubmissionForReferrerResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReferralSubmissionForReferrerResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'status': StatusResponseFromJSON(json['status']),
        'submissionDate': (new Date(json['submissionDate'])),
        'projectTitle': json['projectTitle'],
        'companyName': json['companyName'],
        'referrerRate': json['referrerRate'],
        'submissionId': json['submissionId'],
        'referrerAccountId': json['referrerAccountId'],
        'referrerIdentityId': json['referrerIdentityId'],
    };
}

export function ReferralSubmissionForReferrerResponseToJSON(value?: ReferralSubmissionForReferrerResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'status': StatusResponseToJSON(value['status']),
        'submissionDate': ((value['submissionDate']).toISOString().substring(0,10)),
        'projectTitle': value['projectTitle'],
        'companyName': value['companyName'],
        'referrerRate': value['referrerRate'],
        'submissionId': value['submissionId'],
        'referrerAccountId': value['referrerAccountId'],
        'referrerIdentityId': value['referrerIdentityId'],
    };
}

